<template>
  <img
    v-if="fieldImage && fieldImage.url"
    class="project-teaser-image"
    :src="src"
    :srcset="srcset"
    :sizes="srcset ? sizes : null"
    :width="fieldImage.width || null"
    :height="fieldImage.height || null"
    :alt="fieldImage.alt"
    loading="lazy"
    decoding="async"
  >
</template>

<script>
  // WebP image styles teaser_400/teaser_800 (computed field "teaser_image").
  // The browser picks by rendered width x pixel density: the teaser image is
  // the left grid column (38.2% of max. 53.75em, about 330px) from 48em up,
  // full width below. SVGs have no srcset and use the original.
  const SIZES = '(min-width: 48em) 330px, 100vw'

  export default {
    name: 'FieldImage',
    props: {
      fieldImage: { type: Object, default: null },
    },
    computed: {
      sizes() {
        return SIZES
      },
      srcset() {
        const list = this.fieldImage.srcset || []
        return list.length ? list.map((s) => `${s.url} ${s.width}w`).join(', ') : null
      },
      src() {
        const list = this.fieldImage.srcset || []
        return list.length ? list[0].url : this.fieldImage.url
      },
    },
  }
</script>

<style>
  .project-teaser-image {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
  }
</style>
